/* src/app/views/plans-details-edit/product-details-edit/product-details-edit.component.scss */
.container {
  background: #ffffff;
  -webkit-box-shadow: 0px 3px 5px 0px rgb(184, 175, 184);
  -moz-box-shadow: 0px 3px 5px 0px rgb(184, 175, 184);
  box-shadow: 1.5px 3px 5px 1.5px rgb(184, 175, 184);
}
.container-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  float: left;
  margin-top: 20px;
}
.title-position {
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  width: 100%;
}
.title {
  display: block;
  width: 100%;
  font-weight: normal;
  font-style: normal;
  font-size: clamp(28px, 2.2vw, 48px);
  line-height: 1.2;
  color: #333333;
  margin: 10px 0 0 48px;
}
.loading {
  position: absolute;
  top: 35%;
  left: 50%;
  font-size: 60px;
  font-weight: bold;
}
.sub-title {
  display: block;
  width: 100%;
  font-weight: normal;
  font-style: normal;
  font-size: clamp(14px, 1.1vw, 22px);
  line-height: 1.3;
  color: #5f5f5f;
  margin-top: 2px;
}
.container-body {
  margin-top: 10px;
  margin-bottom: 20px;
  width: 100%;
  border: none;
}
.product-itens {
  padding: 8px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
}
.element-edit {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: initial;
  color: #333333;
  font-family: Ford F-1;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
}
.element-edit-input {
  margin-top: 5px;
}
.element-edit-label {
  margin-bottom: 5px;
}
.space-first {
  margin-left: 60px;
}
.space-second {
  margin-left: 40px;
}
.disabled-input:disabled {
  background-color: #E5E5E5;
  color: #202020;
}
.message-edit {
  margin: 0;
  padding: 0;
}
.char-counter {
  font-size: 12px;
  color: #999999;
  margin-top: 5px;
}
.button-position {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  width: calc(100% - 56px);
  margin: 20px 28px 0;
  padding-top: 18px;
  border-top: 1px solid #d9d9d9;
  box-sizing: border-box;
}
.action-button {
  width: 180px;
  height: 48px;
  padding: 0 18px;
  border-radius: 10px;
  margin-top: 0;
  margin-right: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.action-button-label {
  font-size: 15pt;
  font-weight: 500;
  color: #ffffff;
}
.undo-action-button {
  width: 180px;
  height: 48px;
  padding: 0 18px;
  border-radius: 10px;
  margin-top: 0;
  margin-right: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.undo-action-button-label {
  font-size: 15pt;
  font-weight: 500;
  color: #046cea;
  margin-left: 5px;
}
@media only screen and (max-width: 900px) {
  .container-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .title,
  .sub-title {
    margin-left: 20px;
    font-size: 22pt;
    line-height: 36px;
  }
  .sub-title {
    font-size: 10pt;
    margin-top: 0;
  }
  .space-first,
  .space-second {
    margin-left: 0;
  }
  .product-itens {
    flex-direction: column;
    align-items: stretch;
  }
  .element-edit {
    font-size: 15px;
    line-height: 22px;
  }
  .button-position {
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    width: calc(100% - 32px);
    margin: 16px 16px 0;
    padding-top: 14px;
    padding-bottom: 0;
    gap: 10px;
  }
  .action-button,
  .undo-action-button {
    width: 160px;
    height: 42px;
    margin-right: 0;
    margin-top: 10px;
  }
}
@media only screen and (max-width: 600px) {
  .container-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .title {
    margin-left: 0;
    font-size: 18pt;
    line-height: 28px;
  }
  .sub-title {
    font-size: 9pt;
    margin-left: 0;
    line-height: 20px;
    margin-top: 0;
  }
  .space-first,
  .space-second {
    margin-left: 0;
  }
  .product-itens {
    flex-direction: column;
    align-items: stretch;
    padding: 0;
  }
  .element-edit {
    font-size: 14px;
    line-height: 20px;
  }
  .button-position {
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    width: calc(100% - 32px);
    margin: 14px 16px 0;
    padding-top: 12px;
    padding-bottom: 0;
    gap: 8px;
  }
  .action-button,
  .undo-action-button {
    width: 140px;
    height: 38px;
    margin-right: 0;
    margin-top: 8px;
  }
}
@media only screen and (max-width: 400px) {
  .title {
    font-size: 14pt;
    line-height: 22px;
  }
  .sub-title {
    font-size: 8pt;
    line-height: 16px;
  }
  .action-button,
  .undo-action-button {
    width: 100%;
    height: 38px;
    font-size: 10pt;
  }
}
.product-itens {
  padding: 8px 36px 0;
  max-width: 1240px;
  margin: 0 auto;
}
.product-itens > .element-edit {
  flex: 0 0 33.3333% !important;
  max-width: 33.3333% !important;
  padding: 0 12px 16px;
}
.product-itens > .message-edit {
  flex: 0 0 100% !important;
  max-width: 100% !important;
  width: 100%;
  margin: 0;
  padding: 0 !important;
}
.product-itens > .message-edit > .element-edit {
  flex: 0 0 100% !important;
  max-width: 100% !important;
  padding: 0 12px 16px;
}
.space-first,
.space-second {
  margin-left: 0 !important;
}
@media only screen and (max-width: 768px) {
  .product-itens {
    padding: 8px 16px 0;
  }
  .product-itens > .element-edit,
  .product-itens > .message-edit > .element-edit {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}
/*# sourceMappingURL=product-details-edit.component-AVFXJHLI.css.map */
